import { render, staticRenderFns } from "./RegistMemberCard.vue?vue&type=template&id=9e8e0a4e&scoped=true&"
import script from "./RegistMemberCard.vue?vue&type=script&lang=js&"
export * from "./RegistMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./RegistMemberCard.vue?vue&type=style&index=0&id=9e8e0a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e8e0a4e",
  null
  
)

export default component.exports